import { render, staticRenderFns } from "./add.vue?vue&type=template&id=8b7bbd9a&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=8b7bbd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bbd9a",
  null
  
)

export default component.exports